import React, { useState } from 'react'
import DogEar from '../DogEar/DogEar.js'
import "./Tabs.scss"


/*
  The generic Tabs component takes props of the form (using TypeScript / C# generic type annotations):

  {
      tabsArray: Array<T1>
      tabComponent: Func<T2, React.Element>,
      tabContentComponent: Func<T2, React.Element>
  }

  Where T2 is just T1 with the additional properties `tabIndex`, `visited`, and `selected`.
*/

const Tabs = (props) => {

    const { tabsArray, className, defaultSelectedIndex=0, onProgress, onSelect, onComplete, tabContentComponent } = props
    const defaultTabComponent = props => <DogEar onClick={props.onClick} length={props.length} selected={props.selected} index={props.tabIndex} >
        {props.name}
    </DogEar>;
    const tabComponent = props.tabComponent || defaultTabComponent;
    const [ selectedIndex, setSelectedIndex ] = useState(defaultSelectedIndex)

    const [visitedTabs, setVisitedTabs] = useState(tabsArray.map((x, i) => i == selectedIndex));


    const onTabSelected = (index) => {
        setSelectedIndex(index);
        if(onSelect) onSelect(index);
        visitedTabs[index] = true;
        setVisitedTabs(visitedTabs);
        if(onProgress) {
            onProgress(visitedTabs.filter(x => x).length / visitedTabs.length);
        }
        // this aint right, user does not get to see the final tab, they are whisked away as soon as they click it.
        // if(visitedTabs.every(x => x) && onComplete) {
        //     onComplete();
        // } 
    }

    
    return (
        <div className={`tabs-container ${className}`}>
            <div className="tabs-navigation">
                {tabsArray.map((tab, i) => {
                    const selected = i === selectedIndex;
                    return tabComponent({...tab, 
                        key: i,
                        onClick: (() => onTabSelected(i)),
                        length: tabsArray.length, 
                        tabIndex: i, 
                        visited: visitedTabs[i], 
                        selected
                    });
                })}
            </div>
            <div className="tabs-content">
                {tabContentComponent({...tabsArray[selectedIndex], length: tabsArray.length, tabIndex: selectedIndex})}
            </div>
        </div>
    );
}

export default Tabs